var bighouse = bighouse || {};

bighouse.reviews = (function () {


    function init() {

        if ($('.js-reviewsCarousel').length <= 0)
            return;


        $('.js-reviewsCarousel').each(function(e){
            var arrowsContainer = $(this).parent().find('.Reviews-arrows-inner');

            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                lazyLoad: 'ondemand',
                focusOnSelect: false,
                infinite: true,
                autoplay: false,
                dots: false,
                appendArrows: $(arrowsContainer),
                prevArrow: '<button type="button" class="Reviews-prev"><span class="u-visuallyHidden">Previous</span></button>',
                nextArrow: '<button type="button" class="Reviews-next"><span class="u-visuallyHidden">Next</span></button>'
            });
        });



        resizeFunc();

        var debounceResize = util.debounce(resizeFunc, 100);
        $(window).on('resize', debounceResize);
    }


    function resizeFunc() {
        $('.Reviews-slide').css('height', 'auto');

        $('.js-reviewsCarousel').each(function(e){
            var thisheight = $(this).height();
            $(this).find('.Reviews-slide').css('height', thisheight + 'px');
        });

    }

    
    return {
        init: init
    };
})();